import { Component } from 'react';
import analytics, { FIELD_IDS } from '../../services/analytics';

const STEP_NUMBER = 4; // logement.js is step 4

class ContactInfo extends Component {
	constructor(props) {
		super(props);
		this.fieldTracker = analytics.getFieldTracker();
		this.state = {
			lastName: props.initialValue?.lastName || '',
			firstName: props.initialValue?.firstName || '',
			email: props.initialValue?.email || '',
			phoneNumber: props.initialValue?.phoneNumber || '',
			errors: []
		};
	}

	// Format phone number to French format
	formatPhoneNumber = (value) => {
		const phoneNumber = value.replace(/\D/g, '');
		if (!phoneNumber) return '';
		const truncated = phoneNumber.substring(0, 10);
		let formatted = '';
		for (let i = 0; i < truncated.length; i++) {
			if (i > 0 && i % 2 === 0) formatted += ' ';
			formatted += truncated[i];
		}
		return formatted;
	}

	handleChangeContact = (e) => {
		const name = e.target?.name;
		const value = e.target?.value ?? '';
		const fieldIdMap = {
			'lastName': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_nom,
			'firstName': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_prenom,
			'email': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_email,
			'phoneNumber': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_telephone,
		};
		const fieldId = fieldIdMap[name] || `FIELD_CONTACT_${name.toUpperCase()}`;
		this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, value);

		if (name === 'phoneNumber') {
			const formattedValue = this.formatPhoneNumber(value);
			this.setState({ phoneNumber: formattedValue }, this.notifyParent);
		} else {
			this.setState({ [name]: value }, this.notifyParent);
		}
	}

	notifyParent = () => {
		if (this.props.onContactInfoChange) {
			this.props.onContactInfoChange(this.getData());
		}
	}

	getData = () => {
		return {
			lastName: this.state.lastName,
			firstName: this.state.firstName,
			email: this.state.email,
			phoneNumber: this.state.phoneNumber.replace(/\s/g, ''),
		};
	}

	validateSelection = () => {
		let errors = [];
		if (!this.state.lastName.trim()) {
			errors.push("Veuillez saisir votre nom.");
			analytics.trackValidationError(STEP_NUMBER, 'LASTNAME_REQUIRED', 'lastName');
		}
		if (!this.state.firstName.trim()) {
			errors.push("Veuillez saisir votre prénom.");
			analytics.trackValidationError(STEP_NUMBER, 'FIRSTNAME_REQUIRED', 'firstName');
		}
		if (!this.state.email.trim()) {
			errors.push("Veuillez saisir votre email.");
			analytics.trackValidationError(STEP_NUMBER, 'EMAIL_REQUIRED', 'email');
		} else if (!/\S+@\S+\.\S+/.test(this.state.email)) {
			errors.push("Veuillez saisir une adresse email valide.");
			analytics.trackValidationError(STEP_NUMBER, 'EMAIL_FORMAT', 'email');
		}
		if (!this.state.phoneNumber.trim()) {
			errors.push("Veuillez saisir votre numéro de téléphone.");
			analytics.trackValidationError(STEP_NUMBER, 'PHONE_REQUIRED', 'phoneNumber');
		} else {
			const cleanPhoneNumber = this.state.phoneNumber.replace(/\s/g, '');
			if (cleanPhoneNumber.length !== 10) {
				errors.push("Veuillez saisir un numéro de téléphone valide (10 chiffres).");
				analytics.trackValidationError(STEP_NUMBER, 'PHONE_FORMAT', 'phoneNumber');
			}
		}

		this.setState({ errors });
		return errors.length === 0;
	}

	render() {
		return (
			<div className="question contact-info">
				<h3>Informations de contact</h3>
				<div className="contact-form">
					<div className="form-group">
						<input
							type="text"
							id="lastName"
							name="lastName"
							value={this.state.lastName}
							onChange={this.handleChangeContact}
							placeholder="Nom"
						/>
					</div>

					<div className="form-group">
						<input
							type="text"
							id="firstName"
							name="firstName"
							value={this.state.firstName}
							onChange={this.handleChangeContact}
							placeholder="Prénom"
						/>
					</div>

					<div className="form-group">
						<input
							type="email"
							id="email"
							name="email"
							value={this.state.email}
							onChange={this.handleChangeContact}
							placeholder="Email"
						/>
					</div>

					<div className="form-group">
						<input
							type="tel"
							id="phoneNumber"
							name="phoneNumber"
							value={this.state.phoneNumber}
							onChange={this.handleChangeContact}
							placeholder="Téléphone mobile (Format: 06 12 34 56 78)"
						/>
						<small>Format: 06 12 34 56 78</small>
					</div>
				</div>
				{this.state.errors.length > 0 && (
					<div className="validation-error" style={{ color: 'red', marginTop: '10px' }}>
						{this.state.errors.map((error, idx) => (
							<div key={idx}>{error}</div>
						))}
					</div>
				)}
			</div>
		);
	}
}

export default ContactInfo;
